/**
 * Sidebar Navigation
 */

// Open menu sections
$('.nav-page-sidebar li.current_page_item')
  .parents('li.page_item_has_children')
  .toggleClass('is-open')
  .children('.children')
  .show();

if (
  $('.nav-page-sidebar li.current_page_item').hasClass('page_item_has_children')
) {
  $('.nav-page-sidebar li.current_page_item')
    .toggleClass('is-open')
    .children('.children')
    .show();
}

// Remove the `no-transition` class from the nav so toggle transitions will show
$('.nav-page-sidebar').removeClass('no-transition');

// Toggle nested menu items
$('.nav-page-sidebar .toggle').on('click', event => {
  event.preventDefault();
  $(event.currentTarget)
    .parent('a')
    .parent('li')
    .toggleClass('is-open')
    .children('.children')
    .slideToggle('show');
});



// WEBPACK FOOTER //
// ./assets/js/components/nav-sidebar.js